import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { useOnClickOutside } from 'utils/helpers';
import './ButtonDropdown.scss';

const ButtonDropdown = ({
  buttonElement,
  isDropdownBlocked,
  children,
  dropdownPosition,
  dropdownVerticalPosition,
  isFixedHeight,
  isFullHeight,
  isFullWidth,
  isItemsEmpty,
  onCloseDropdown,
  dropDownCloseStatus,
}) => {
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    setDropdownIsOpen(dropDownCloseStatus);
  }, [dropDownCloseStatus]);

  useOnClickOutside(ref, () => {
    setDropdownIsOpen(false)
    onCloseDropdown(false);
  });

  const buttonDropdownStyles = classNames({
    'ButtonDropdownNotifContainer': true,
    'ButtonDropdownNotifContainerLeft': dropdownPosition === 'left',
    'ButtonDropdownNotifContainerRight': dropdownPosition === 'right',
    'ButtonDropdownNotifContainerFixedHeight': isFixedHeight,
    'ButtonDropdownNotifContainerFullHeight': isFullHeight,
    'ButtonDropdownNotifContainerEmpty': isItemsEmpty,
    'ButtonDropdownNotifContainerTop': dropdownVerticalPosition === 'top',
  });

  const handleDropdownIsOpen = () => {
    setDropdownIsOpen(!dropdownIsOpen);
  };

  return (
    <div
      ref={ref}
      className={
        classNames({
          'ButtonDropdownContainer': true,
          'ButtonDropdownContainerCenter': dropdownPosition === 'center',
        })
      }
    >
      <div
        className="ButtonDropdownButtonWrapper"
        onClick={handleDropdownIsOpen}
      >
        {buttonElement}
      </div>

      {dropdownIsOpen && !isDropdownBlocked &&
        <div
          className={buttonDropdownStyles}
        >
          {children}
        </div>
      }
    </div>
  );
};

export default ButtonDropdown;